import siteBase from "./site-base.json";

export type { BlogPost, BlogFrontmatter } from "@/utils/blog";
export {
  parseFrontmatter,
  slugFromFilename,
  extractBlogTitle,
  stripMarkdown,
  sortBlogPosts,
  fetchBlogPost,
  fetchAllBlogPosts,
  formatBlogDate,
} from "@/utils/blog";

export interface WorkExperience {
  title: string;
  position: string;
  duration: string;
  description: string[];
}

export interface Project {
  title: string;
  category: string;
  link: string;
  blurb: string;
}

export interface NavPage {
  name: string;
  route: string;
  description: string;
}

export const blogFiles: string[] = siteBase.blogFiles;
export const siteUrl: string = siteBase.siteUrl;
export const siteBaseData = siteBase;
